export const decodeJWT = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
};

export const getTokenPayload = () => {
  const token = localStorage.getItem('access-token');
  if (!token) return null;
  return decodeJWT(token);
};

export const syncUserFromToken = (accessToken, refreshToken) => {
  if (accessToken) {
    localStorage.setItem('access-token', accessToken);
  }
  if (refreshToken) {
    localStorage.setItem('refresh-token', refreshToken);
  }
  const token = accessToken || localStorage.getItem('access-token');
  if (!token) return null;

  const payload = decodeJWT(token);
  if (!payload) return null;

  if (payload.email) localStorage.setItem('email', payload.email);
  if (payload.username) localStorage.setItem('username', payload.username);
  if (payload.user_id) localStorage.setItem('user_id', payload.user_id);
  localStorage.setItem('user_type', payload.user_type || 'user');
  if (payload.vendor_id != null) {
    localStorage.setItem('vendor_id', String(payload.vendor_id));
  } else {
    localStorage.removeItem('vendor_id');
  }
  if (payload.vendor_contact) {
    localStorage.setItem('vendor_contact', payload.vendor_contact);
  } else {
    localStorage.removeItem('vendor_contact');
  }

  return payload;
};

export const isAdminUser = () => {
  const payload = getTokenPayload();
  if (payload?.user_type === 'admin') return true;
  return localStorage.getItem('user_type') === 'admin';
};

export const isVendorUser = () => {
  const payload = getTokenPayload();
  if (payload?.user_type === 'vendor') return true;
  return localStorage.getItem('user_type') === 'vendor';
};

export const isStaffUser = () => {
  const payload = getTokenPayload();
  const userType = payload?.user_type || localStorage.getItem('user_type');
  return userType === 'admin' || userType === 'user';
};

export const getVendorContact = () => {
  const payload = getTokenPayload();
  return payload?.vendor_contact || localStorage.getItem('vendor_contact') || '';
};

export const getPostLoginPath = (payload) => {
  const userType = payload?.user_type || localStorage.getItem('user_type');
  if (userType === 'vendor') return '/vendor/home';
  return '/home';
};

export const getVendorDisplayName = () => {
  const payload = getTokenPayload();
  const name = payload?.username || localStorage.getItem('username');
  if (name?.trim()) return name.trim();
  const email = payload?.email || localStorage.getItem('email');
  if (email) return email.split('@')[0];
  return 'Seller';
};

export const getProfileInitial = () => {
  const name = getVendorDisplayName();
  return name.charAt(0).toUpperCase();
};
